import {imageLoadedPromise} from './image-loaded';

export default function replaceImageWithSvgSource(image) {
	// wait for image to load
	return imageLoadedPromise(image)
		// fetch image content
		.then(() => fetch(image.src, {cache: 'force-cache'}))
		.then(response => {
			const type = response.headers.get('content-type');
			if (type !== 'image/svg+xml') {
				throw new Error(`Wrong Content-Type ${type} for image ${image.src}.`);
			}
			return response;
		})
		.then(response => response.text())
		.then(html => {
			const fragment = document.createElement('div');
			fragment.insertAdjacentHTML('afterbegin', html);
			const svg = fragment.firstElementChild;
			const classes = image.getAttribute('class');
			classes && svg.setAttribute('class', classes);
			const alt = image.getAttribute('alt');
			if (alt) {
				svg.setAttribute('role', 'img');
				svg.insertAdjacentHTML('afterbegin', `<title>${alt}</title>`);
			} else {
				svg.setAttribute('aria-hidden', 'true');
			}
			image.insertAdjacentElement('afterend', svg);
			image.remove();
			return svg;
		})
		.catch(console.error)
		;
}
